import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function MouseFollower() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const [hovering, setHovering] = useState(false);

  const dotX = useSpring(x, { stiffness: 600, damping: 40, mass: 0.4 });
  const dotY = useSpring(y, { stiffness: 600, damping: 40, mass: 0.4 });
  const ringX = useSpring(x, { stiffness: 130, damping: 20, mass: 0.6 });
  const ringY = useSpring(y, { stiffness: 130, damping: 20, mass: 0.6 });

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const el = e.target;
      const interactive = el?.closest?.("a, button, [role='button'], input, textarea, video");
      setHovering(!!interactive);
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  return (
    <div className="hidden md:block pointer-events-none fixed inset-0 z-[9998] mix-blend-difference" aria-hidden="true">
      <motion.div
        style={{ x: ringX, y: ringY }}
        animate={{ scale: hovering ? 1.8 : 1, opacity: hovering ? 0.9 : 0.5 }}
        transition={{ type: "spring", stiffness: 200, damping: 20 }}
        className="absolute -ml-5 -mt-5 w-10 h-10 rounded-full border border-white"
      />
      <motion.div
        style={{ x: dotX, y: dotY }}
        animate={{ scale: hovering ? 0 : 1 }}
        className="absolute -ml-[3px] -mt-[3px] w-1.5 h-1.5 rounded-full bg-white"
      />
    </div>
  );
}
